import * as React from 'react';

import {ActionBox} from 'shells/action-box/action-box';
import {ErrorIcon} from 'shells/action-box/action-icons';
import {Link} from 'shells/link/link';

type Props = {
    hasShortLink: boolean;
};

export function LinkActionBox(props: Props) {
    return (
        props.hasShortLink && (
            <ActionBox
                title='Unsupported short links'
                subtitle='Public URL shorteners are not supported'
                icon={<ErrorIcon />}
                actionElement={
                    <Link
                        href='https://support.nutshell.com/en/articles/10429742-how-to-send-bulk-sms-and-set-up-automated-sms-drip-sequences#h_40e1a2d43e'
                        variant='primary'
                        newTab={true}
                    >
                        Learn why
                    </Link>
                }
            />
        )
    );
}
